import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * upload image to server and return imageUrl
 * @param {String} image encoded base64 Image string
 */
const uploadImage = async function (base64Image) {
  try {
    let data = {
      encodedImage: base64Image
    }
    let res = await axios.post(urls.uploadImage, data)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

/**
 * upload csv to server
 * @param {FormData} formData csv data
 */
const uploadCsv = async function (formData) {
  console.log('TCL: formData', formData.entries())
  for (let pair of formData.entries()) {
    console.log('TCL: pair', pair)
  }
  try {
    let res = await axios.post(
      urls.uploadCsv,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch uploaded csv data process status
 * @param {Object} filter list filter
 *  @param {Number} filter.page list page
 *  @param {Number} filter.size list size
 *  @param {String} [filter.sort] list sorting
 *  @param {Type} filter.type list data type
 *  @param {Number} filter.uploadFrom csv uploaded time from
 *  @param {Number} filter.uploadTo csv uploaded time to
 */
const fetchUploadedCsvDataProcessStatus = async function (filter) {
  try {
    let data = {
      ...filter,
      page: filter.page - 1
    }
    let res = await axios.get(urls.uploadedCsvStatus + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch uploaded csv data detail
 * @param {Object} filter list filter
 *  @param {Number} filter.id list id
 *  @param {Number} filter.page list page
 *  @param {Number} filter.size list size
 *  @param {String} [filter.sort] list sorting
 */
const fetchUploadedCsvDataProcessDetail = async function (filter) {
  try {
    let data = {
      ...filter,
      page: filter.page - 1
    }
    let res = await axios.get(urls.uploadedCsvDetail + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch data for master data csv upload template
 * @param {String} dataType csv template data type
 */
const fetchCsvTemplateData = async function (dataType) {
  console.log('TCL: dataType', dataType)
  try {
    let res = await axios.get(urls.csvTemplateData + '?' + querystring.stringify({ type: dataType }))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  uploadImage,
  uploadCsv,
  fetchUploadedCsvDataProcessStatus,
  fetchUploadedCsvDataProcessDetail,
  fetchCsvTemplateData,
}
